import apiClient from '../utils/apiClient';

/**
 * Bàn giao công việc cho ca sau (có duyệt) — màn admin duyệt yêu cầu của nhân viên.
 * Backend: ADMIN duyệt mọi chi nhánh, MANAGER chỉ đúng chi nhánh của mình (backend tự ép).
 */
export const shiftTaskHandoverAPI = {
  /**
   * @param {Object} params
   * @param {string} [params.status] - PENDING|APPROVED|AUTO_APPROVED|REJECTED|CANCELLED, bỏ trống = tất cả
   * @param {string} [params.branch_id]
   * @param {string} [params.from] - ISO date YYYY-MM-DD
   * @param {string} [params.to] - ISO date YYYY-MM-DD
   * @param {number} [params.page]
   * @param {number} [params.limit]
   */
  list: async (params = {}) =>
    apiClient.get({ url: '/shift-tasks/handover-requests', params }),

  approve: async (shiftTaskId, requestId) =>
    apiClient.patch({
      url: `/shift-tasks/${shiftTaskId}/handover-requests/${requestId}/approve`,
      data: {},
    }),

  reject: async (shiftTaskId, requestId, reason) =>
    apiClient.patch({
      url: `/shift-tasks/${shiftTaskId}/handover-requests/${requestId}/reject`,
      data: { reason },
    }),
};
